import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const RankingIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M8.67 14H4C2.9 14 2 14.9 2 16V22H8.67V14Z" />

		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M13.33 10H10.66C9.56 10 8.66 10.9 8.66 12V22H15.33V12C15.33 10.9 14.44 10 13.33 10Z"
		/>

		<path opacity={0.4} fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M20 17H15.33V22H22V19C22 17.9 21.1 17 20 17Z" />

		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12.52 2.07L13.05 3.13C13.12 3.28 13.31 3.42 13.47 3.44L14.43 3.6C15.04 3.7 15.19 4.15 14.75 4.58L14 5.33C13.87 5.46 13.8 5.7 13.84 5.87L14.05 6.79C14.22 7.52 13.83 7.8 13.19 7.42L12.29 6.89C12.13 6.79 11.86 6.79 11.7 6.89L10.8 7.42C10.16 7.8 9.77 7.52 9.94 6.79L10.15 5.87C10.19 5.7 10.12 5.45 9.99 5.33L9.25 4.59C8.81 4.15 8.95 3.71 9.57 3.61L10.53 3.45C10.69 3.42 10.88 3.28 10.95 3.14L11.48 2.08C11.77 1.5 12.23 1.5 12.52 2.07Z"
		/>
	</SvgIcon>
)

export default RankingIconAtom
